// Auth provider configuration
import { AUTH_PROVIDERS } from '@/consts/auth.consts';
import type { AuthProvider } from '@/services/auth/authProvider.types';

interface DescopeConfig {
  projectId: string;
}

interface AuthConfig {
  config?: DescopeConfig;
  provider: AuthProvider;
}

export const useAuthConfig = (): AuthConfig => {
  return {
    provider: AUTH_PROVIDERS.FIREBASE,
  };
};
